function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { MARKETER_PRODUCT_TYPE, PROJECTS_PRODUCT_TYPE } from "constants/products";
import DefaultProps from "./default-props";
import { StyledProductCardsGridMobileComponent } from "./product-cards-grid-mobile-component.scss";
import ProductCardGridMobileComponent from "./product-card-grid-component/product-card-grid-mobile-component";
const ProductCardsGridMobileComponent = (props)=>{
    var _props_cards;
    return /*#__PURE__*/ _jsx(StyledProductCardsGridMobileComponent, {
        className: "product-cards-grid-mobile-component",
        children: props === null || props === void 0 ? void 0 : (_props_cards = props.cards) === null || _props_cards === void 0 ? void 0 : _props_cards.filter((card)=>card.productType !== MARKETER_PRODUCT_TYPE && card.productType !== PROJECTS_PRODUCT_TYPE).map((card, index)=>/*#__PURE__*/ _createElement(ProductCardGridMobileComponent, _object_spread_props(_object_spread({}, card), {
                key: index,
                index: index
            })))
    });
};
ProductCardsGridMobileComponent.defaultProps = DefaultProps;
export default ProductCardsGridMobileComponent;
